module.exports = __webpack_public_path__ + "img/upload_image_icon.b15573e9.svg";